/*
  Custom jewelry menu image previews.
  Decode images before crossfading and discard stale hover requests.
  Menu opening, keyboard traversal and Escape remain native Origin behavior.
*/
function initialize(menu) {
  const fronts = [...menu.querySelectorAll('[data-preview-front]')];
  const backs = [...menu.querySelectorAll('[data-preview-back]')];
  const slots = [...menu.querySelectorAll('.ts-design-menu-picture')];
  if (!fronts.length || fronts.length !== backs.length || slots.length !== fronts.length || menu.dataset.connected) return;
  menu.dataset.connected = 'true';
  const panel = menu.querySelector('.ts-design-menu-preview');
  const decoded = new Map();
  let sequence = 0;
  let timer;
  let activeAnchor;
  function load(source) {
    if (!decoded.has(source)) {
      const image = new Image();
      image.src = source;
      decoded.set(source, image.decode().then(() => image).catch((error) => {
        decoded.delete(source);
        throw error;
      }));
    }
    return decoded.get(source);
  }
  async function preview(anchor) {
    if (activeAnchor === anchor) return;
    activeAnchor = anchor;
    const current = ++sequence;
    clearTimeout(timer);
    let sources;
    try { sources = JSON.parse(anchor.dataset.designPreviews); } catch { sources = []; }
    if (!Array.isArray(sources)) sources = [];
    sources = sources.filter((source) => typeof source === 'string' && source).slice(0, fronts.length);
    if (!sources.length) {
      if (panel) panel.hidden = true;
      return;
    }
    const results = await Promise.allSettled(sources.map(load));
    if (current !== sequence) return;
    const images = results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
    if (images.length < sources.length) activeAnchor = null;
    if (panel) panel.hidden = images.length === 0;
    backs.forEach((back, index) => {
      slots[index].hidden = !images[index];
      if (!images[index]) return;
      if (back.classList.contains('visible')) fronts[index].src = back.src;
      fronts[index].removeAttribute('srcset');
      back.style.transition = 'none';
      back.classList.remove('visible');
      back.hidden = false;
      back.src = images[index].src;
    });
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (current !== sequence) return;
      backs.forEach((back, index) => {
        if (!images[index]) return;
        back.style.removeProperty('transition');
        back.classList.add('visible');
      });
    }));
    timer = setTimeout(() => {
      if (current !== sequence) return;
      fronts.forEach((front, index) => { if (images[index]) front.src = images[index].src; });
    }, 300);
  }
  menu.querySelectorAll('[data-design-previews]').forEach((anchor) => {
    anchor.addEventListener('mouseenter', () => preview(anchor));
    anchor.addEventListener('focus', () => preview(anchor));
  });
}
document.querySelectorAll('[data-design-menu]').forEach(initialize);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-design-menu]').forEach(initialize);
});
